/** Moldura das telas de acesso que ficam fora do app: primeiro acesso e
 *  recuperação de senha.
 *
 *  Reaproveita o CSS bespoke do login (`login.css`) para que as três telas sejam
 *  a mesma peça: hero com a foto sangrando na direita, painel claro à esquerda com
 *  o logo, a marca d'água da folha e o rodapé. O conteúdo interno vem em MUI
 *  temado, que já carrega o raio-folha nos campos e nos botões.
 *
 *  Veste o hub escolhido no login, sem o seletor: estas telas chegam por link.
 *
 *  A tela de login continua com o markup próprio dela, de propósito: os campos
 *  daquele formulário são bespoke, não MUI, e trocar isso agora seria mexer na
 *  porta de entrada do sistema sem necessidade.
 */
import { Link } from 'react-router-dom'
import { useHubLembrado } from '@/core/hubs/hubs'
import { HeroDoHub, MarcaDoHub, RodapeDoHub } from './hubs/MolduraDoHub'
import './login.css'

interface Props {
  titulo: string
  subtitulo: string
  children: React.ReactNode
  /** Link discreto no rodapé do painel, normalmente de volta para o login. */
  voltar?: { para: string; texto: string }
}

export function AuthLayout({ titulo, subtitulo, children, voltar }: Props) {
  const hub = useHubLembrado()

  return (
    <main className="login-stage" data-hub={hub}>
      <HeroDoHub hub={hub} />

      <section className="login-form">
        <svg className="login-wm" viewBox="0 0 588 289" aria-hidden="true">
          <use href="#leaf" />
        </svg>

        <MarcaDoHub hub={hub} />

        <div className="login-body">
          <div className="login-welcome">
            <h1>
              <svg className="login-bullet" viewBox="0 0 588 289" aria-hidden="true">
                <use href="#leaf" />
              </svg>
              {titulo}
            </h1>
            <p>{subtitulo}</p>
          </div>

          <div className="login-fields">{children}</div>

          {voltar && (
            <p style={{ marginTop: 20, fontSize: 14 }}>
              <Link className="login-forgot" to={voltar.para}>
                {voltar.texto}
              </Link>
            </p>
          )}
        </div>

        <RodapeDoHub hub={hub} />
      </section>
    </main>
  )
}
